import { render, staticRenderFns } from "./SelectSubDistrict.vue?vue&type=template&id=d375d856&"
import script from "./SelectSubDistrict.vue?vue&type=script&lang=js&"
export * from "./SelectSubDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports